import api from 'services/api.service';

const resource = '/storage';

export const copy = ({ bucket, fromPath, toPath }) => api
  .post(`${resource}/copy`, { bucket, fromPath, toPath });

export const download = ({ bucket, path }) => api
  .post(`${resource}/download`, { bucket, path });

export const getPublicUrl = ({ bucket, path }) => api
  .post(`${resource}/get-public-url`, { bucket, path });

export const getSignedUrl = ({ bucket, path }) => api
  .post(`${resource}/get-signed-url`, { bucket, path });

export const remove = ({ bucket, path }) => api
  .post(`${resource}/remove`, { bucket, path });

export const upload = (formData) => api
  .post(`${resource}/upload`, formData);
